export default "__VITE_ASSET__abd6982e__"